
import { required } from 'vuelidate/lib/validators'
import licencePlateMixin from '@/mixins/licencePlateMixin'
import vehicleSelectionTargetMixin from '@/mixins/vehicleSelectionTargetMixin'
import VehicleSelectionModal from '@/components/VehicleSelectionModal.vue'

export default {
  name: 'LedSearchLicencePlateForm',

  components: {
    VehicleSelectionModal,
  },

  mixins: [licencePlateMixin, vehicleSelectionTargetMixin],

  props: {
    countryOverride: {
      type: String,
      default: null,
    },
    useExternalModal: {
      type: Boolean,
      default: false,
    },
    initialPlate: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      form: {
        licence_plate: (this.initialPlate || '').toUpperCase(),
      },
      searchingLicencePlate: false,
      vehicles_list: [],
      uniqueId: `input-licence-plate-${Math.random()
        .toString(36)
        .substring(2, 11)}`,
    }
  },

  validations() {
    return {
      form: {
        licence_plate: {
          required,
          validFormat: value => this.validateLicencePlate(value),
        },
      },
    }
  },

  computed: {
    countryCode() {
      return this.countryOverride || this.currentCountryCode
    },
    countryIso() {
      const country = this.countryOverride || this.currentCountryCode
      const config = this.licencePlateCountries[country]
      return config ? config.displayIso : this.licencePlateDisplayIso
    },
    isPlateComplete() {
      return this.validateLicencePlate(
        this.form.licence_plate,
        this.countryCode
      )
    },
    placeholderExample() {
      const examples = this.getLicencePlateExamples(this.countryCode)
      return examples.length > 0 ? examples[0] : 'AB-123-CD'
    },
  },

  watch: {
    initialPlate(value) {
      this.form.licence_plate = (value || '').toUpperCase()
    },
    'form.licence_plate'(newVal) {
      if (!newVal) {
        this.$v.form.licence_plate.$reset()
      }
    },
  },

  methods: {
    loadProducts(vehicle) {
      const enrichedVehicle = {
        ...vehicle,
        search: this.form.licence_plate || null,
      }

      const consumed = this.consumeVehicleSelectionTarget(enrichedVehicle)

      this.$emit('vehicleSelected', enrichedVehicle)

      this.$emit('closeModal')

      if (consumed) return

      this.$router.push(
        this.localePath({
          name: 'recherche-led-accessoires-brand-type-typeid',
          params: {
            brand: vehicle.brand.name.toLowerCase(),
            type: vehicle.name.toLowerCase(),
            typeid: vehicle.id,
          },
        })
      )
    },

    onSubmit() {
      if (this.searchingLicencePlate) return

      this.$v.$touch()
      if (!this.$v.$anyError) {
        this.searchingLicencePlate = true

        let registration = this.form.licence_plate
          .replace(/[\s-]/g, '')
          .toLowerCase()
        const country = this.countryOverride || this.currentCountryCode
        let countryCode = 'fr'

        if (country !== 'FR') {
          const config = this.licencePlateCountries[country]
          if (config && config.autoWaysCode) {
            countryCode = config.autoWaysCode
          }
        }

        this.$vehicleService
          .fetchByRegistration(registration, countryCode)
          .then(({ data, unknown_registration }) => {
            if (data.length == 0) {
              this.$store.dispatch('setUnknownRegistration', {
                id: unknown_registration.id,
                email: unknown_registration.email,
                license_plate_used: this.form.licence_plate,
              })
              this.$bvModal.show('modalAddAlertUnknownRegistration')
            } else if (data.length == 1) {
              this.loadProducts(data[0])
              this.$emit('closeModal')
            } else if (data.length > 1) {
              this.vehicles_list = data
              if (this.useExternalModal) {
                this.$emit('multipleVehiclesFound', {
                  vehicles: data,
                  plate: this.form.licence_plate,
                })
              } else {
                this.$refs.modalVehicles.show()
              }
            }
          })
          .catch(() => {
            this.$swalInfoCustomMessage(
              this.$t('components.ledSearchFormLicencePlate.unknownPlateTitle'),
              `${this.$t(
                'components.ledSearchFormLicencePlate.unknownPlateMessagePart1'
              )} <b class="font-weight-bold">${this.$t(
                'components.ledSearchFormLicencePlate.unknownPlateMessagePart2'
              )}</b>`
            )
            this.$emit('plateNotFound')
          })
          .finally(() => {
            this.searchingLicencePlate = false
          })
      }
    },

    filterInput(event) {
      const char = event.key

      if (
        typeof char === 'string' &&
        char.length === 1 &&
        !this.isCharAllowedForCountry(char.toUpperCase(), this.countryCode)
      ) {
        event.preventDefault()
      }
    },
  },
}
